import * as types from 'actions/actionTypes';
import initialState from './initialState';

/**
 * reducer per gestire le interrogazioni a crashboxx/services/icnplus
 * @param {*} state
 * @param {*} action
 */
export default function icnPlusReducer(state = initialState.icnPlusSearch, action){

    switch(action.type)
    {
        case types.GET_ICNPLUS_REQUEST:
            return {...state, item: null, error: null, isSearching: true};
        case types.GET_ICNPLUS_SUCCESS:
            return {...state, item: action.data.icnplus, error: null, isSearching: false};
        case types.GET_ICNPLUS_ERROR:
            return {...state, error: action.data, isSearching: false};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/icnPlusReducer.js